import { Badge, Group } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { TruncatedHeader } from "../../../../mantine/TruncatedHeader";
import type { MeteringOrMarketLocation } from "../../../../utils/backend-types";
import { IconHelpText } from "../../../IconHelpText/IconHelpText";
import type { ConfiguratorComponent } from "../ComponentTable";

function getNonStaffLocationColumns(): Array<
  MRT_ColumnDef<ConfiguratorComponent>
> {
  return [
    {
      header: "Datenempfang Marktkommunikation",
      Header: (
        <Group wrap="nowrap">
          <TruncatedHeader>Datenempfang Marktkommunikation</TruncatedHeader>
          <IconHelpText
            helpText="Es kann sein, dass der Messstellenbetreiber node.energy zurückmeldet,
                      dass ein automatisierter kontinuierlicher Datenempfang für diese
                      Lokationsnummer bei diesem Messstellenbetreiber nicht betrieben werden
                      kann. Dies kann mehrere Gründe haben, über die wir Sie üblicherweise
                      bereits z. B. per E-Mail informiert haben. Sollten Sie Rückfragen zu
                      den Gründen haben, kontaktieren Sie bitte den für Sie zuständigen
                      Customer Success Mitarbeiter."
          />
        </Group>
      ),
      accessorKey: "locationDataReception",
      Cell: ({ cell }) => {
        const locationDataReception =
          cell.getValue<MeteringOrMarketLocation["locationDataReception"]>();

        return (
          <Badge
            color={locationDataReception === "Möglich" ? "primary" : "error"}
            size="sm"
          >
            {locationDataReception}
          </Badge>
        );
      }
    }
  ];
}

export { getNonStaffLocationColumns };
